import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CustomRouter from './helpers/CustomRouter';
import PrivateRoute from './helpers/PrivateRoute';
import { connect } from 'react-redux';
import history from '../history';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material';

import Login from './auth/Login';
import SignUp from './users/SignUp';
import Verify from './users/Verify';
// import Dashboard from './Dashboard';
import theme from './theme';
import Profile from './users/Profile';
import Error from './Error';
import PasswordReset from './auth/PasswordReset';
import PasswordResetPassword from './auth/PasswordResetPassword';
import UsersAdmin from './users/UsersAdmin';
import Copyright from './Copyright';
// import Costs from './costs/Costs';
// import Surveys from './survey/Surveys';
// import SurveySetup from './survey/SurveySetup';
// import FirmographicSetup from './survey/FirmographicSetup';
// import ConjointSetup from './survey/ConjointSetup';
// import GaborGrangerSetup from './survey/GaborGrangerSetup';
// import VanWestendorpSetup from './survey/VanWestendorpSetup';
// import ValueModel from './value/ValueModel';
import ValueModels from './value/ValueModels';
// import Products from './product/Products';
import TakeSurvey from './survey/TakeSurvey';
import Journey from './journey/Journey';
// import SurveyAnalyze from './survey/SurveyAnalyze';
import Presentations from './presentation/Presentations';
import ValueModelJourney from './value/ValueModelJourney';

const drawerWidth = 0;

const App = ({ isSignedIn, role, isRefreshing, startSurvey }) => {
    return (
        <div>
            <CssBaseline />
            <ThemeProvider theme={theme}>
                {/* {isSignedIn && <Header drawerWidth={drawerWidth} />}
                {isSignedIn && <Sidebar drawerWidth={drawerWidth} />}
                <Box sx={{
                    width: { sm: `calc(100% - ${isSignedIn ? drawerWidth : 0}px)` },
                    ml: { sm: `${isSignedIn ? drawerWidth : 0}px` }, backgroundColor: 'background.white',
                    mt: `${isSignedIn ? 70 : 0}px`
                }}> */}
                {!isSignedIn ?
                    <Error />
                    : null}
                <CustomRouter history={history}>
                    <Routes>
                        <Route path="/login" exact element={<Login />} />
                        <Route path="/signup" exact element={<SignUp />} />
                        <Route path="/reset-password/:code" element={<PasswordResetPassword />} />
                        <Route path="/reset-password" exact element={<PasswordReset />} />
                        <Route path="/verify/:verification" exact element={<Verify />} />
                        <Route path="/survey" element={<TakeSurvey />} />
                        <Route path="/" exact element={<PrivateRoute />}>
                            <Route path="/" exact element={<Journey />} />
                        </Route>
                        <Route path="/profile" exact element={<PrivateRoute />}>
                            <Route path="/profile" exact element={<Profile />} />
                        </Route>
                        <Route path="/users/admin" exact element={<PrivateRoute />}>
                            <Route path="/users/admin" exact element={<UsersAdmin />} />
                        </Route>
                        {/* <Route path="/costs" exact element={<PrivateRoute />}>
                            <Route path="/costs" exact element={<Costs />} />
                        </Route> */}
                        {/* <Route path="/surveys" exact element={<PrivateRoute />}>
                            <Route path="/surveys" exact element={<Surveys />} />
                            <Route path="/surveys/survey" element={<SurveySetup />} />
                            <Route path="/surveys/survey/analyze" element={<SurveyAnalyze />} />
                            <Route path="/surveys/firmographic" element={<FirmographicSetup />} />
                            <Route path="/surveys/conjoint" element={<ConjointSetup />} />
                            <Route path="/surveys/gabor-granger" element={<GaborGrangerSetup />} />
                            <Route path="/surveys/van-westendorp" element={<VanWestendorpSetup />} />
                        </Route> */}
                        <Route path="/value-models" exact element={<PrivateRoute />}>
                            <Route path="/value-models" exact element={<ValueModels />} />
                            <Route path="/value-models/value-model" exact element={<ValueModelJourney />} />
                        </Route>
                        <Route path="/presentation" exact element={<PrivateRoute />}>
                            <Route path="/presentation" exact element={<Presentations />} />
                        </Route>
                        {/* <Route path="/journey" exact element={<PrivateRoute />}>
                            <Route path="/journey" exact element={<Journey />} />
                        </Route>                         */}
                    </Routes>
                </CustomRouter>
                <Copyright sx={{ position: 'fixed', bottom: 0, ml: { sm: `${isSignedIn ? drawerWidth + 3 : 3}px` }, zIndex: 9999 }} />
                {/* </Box> */}
            </ThemeProvider>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        startSurvey: state.profile.survey.startSurvey,
        role: state.auth.role,
        isRefreshing: state.auth.isRefreshing
    };
};

export default connect(mapStateToProps)(App);